import { render } from "./SendResetPassword.vue?vue&type=template&id=7d9a9a5e&scoped=true"
import script from "./SendResetPassword.vue?vue&type=script&lang=js"
export * from "./SendResetPassword.vue?vue&type=script&lang=js"

import "./SendResetPassword.vue?vue&type=style&index=0&id=7d9a9a5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9a9a5e"]])

export default __exports__